import CameraResults from '@/data/TRACCIA_FINALE_TROVACOLLEGIO_03_Camera.json';
import SenateResults from '@/data/TRACCIA_FINALE_TROVACOLLEGIO_03_Senato.json';
import { StructureType } from '@/lib/model';

// Get mock results
export const getMockResults = (
  type: StructureType,
  objectId: number | string
) => {
  if (type === StructureType.SENATE) {
    return (
      SenateResults.find(object => object.OBJECTID === `${objectId}`) ||
      SenateResults[0]
    );
  }

  return (
    CameraResults.find(object => object.OBJECTID === `${objectId}`) ||
    CameraResults[0]
  );
};

export const parseResult = (result: string) => {
  const output = parseFloat(result.replaceAll('"', '').replace(',', '.'));
  return Number(output.toFixed(1));
};
